import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import API from "../api";

export default function ResetPassword() {
  const [params]  = useSearchParams();
  const [password, setPassword] = useState("");
  const [done, setDone]         = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");
  const navigate = useNavigate();

  const submit = async () => {
    if (password.length < 6) { setError("Min 6 characters"); return; }
    setLoading(true); setError("");
    try {
      await API.post("/reset-password", { token: params.get("token"), new_password: password });
      setDone(true);
    } catch (e) { setError(e?.response?.data?.detail || "Reset failed."); }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:"100vh",background:"#050510",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'DM Sans',sans-serif",padding:20 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Syne:wght@700;900&display=swap" rel="stylesheet" />
      <div style={{ width:"100%",maxWidth:420 }}>
        <div style={{ textAlign:"center",marginBottom:32 }}>
          <div style={{ fontFamily:"'Syne',sans-serif",fontSize:28,fontWeight:900,color:"#00d4aa",marginBottom:8 }}>⚡ LeadBot Pro</div>
        </div>
        <div style={{ background:"#0d0d1f",border:"1px solid #ffffff11",borderRadius:24,padding:40 }}>
          {done ? (
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:40,marginBottom:16 }}>✅</div>
              <h3 style={{ fontFamily:"'Syne',sans-serif",marginBottom:8,color:"#fff" }}>Password updated!</h3>
              <button onClick={() => navigate("/login")} style={{ marginTop:16,background:"#00d4aa",color:"#050510",border:"none",borderRadius:10,padding:"12px 24px",fontWeight:700,cursor:"pointer" }}>Go to Login</button>
            </div>
          ) : (
            <>
              <label style={{ display:"block",color:"#9ca3af",fontSize:13,marginBottom:8,textTransform:"uppercase",letterSpacing:1 }}>New Password</label>
              <input type="password" placeholder="Min 6 characters" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key==="Enter"&&submit()} style={{ width:"100%",background:"#050510",border:"1px solid #ffffff11",borderRadius:10,padding:"13px 16px",color:"#fff",fontFamily:"'DM Sans',sans-serif",fontSize:15,outline:"none",boxSizing:"border-box",marginBottom:8 }} />
              {error && <p style={{ color:"#f87171",fontSize:13,marginBottom:8 }}>{error}</p>}
              <button onClick={submit} disabled={loading} style={{ width:"100%",marginTop:16,background:loading?"#333":"linear-gradient(135deg,#00d4aa,#00b894)",color:loading?"#666":"#050510",border:"none",borderRadius:12,padding:14,fontWeight:700,fontSize:15,cursor:loading?"not-allowed":"pointer" }}>
                {loading?"Updating...":"Update Password →"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
